import { GridColDef } from "@mui/x-data-grid";

export const unassignedTrailersTableColumns: GridColDef[] = [
    { field: "unitNumber", headerName: "Unit Number", width: 250 },
    { field: "vin", headerName: "VIN", width: 300 },
    { field: "make", headerName: "Make", width: 300 },
    { field: "model", headerName: "Model", width: 250 },
    { field: "year", headerName: "Year", width: 100 },
  ];
  